import React, { useContext, useEffect, useState } from "react";
import { AnalisisCreditoContext } from "./AnalisisCreditoScreen";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import PlantillaScreen from "../helpers/PlantillaScreen";
import { LoaderScreen } from "../components/LoaderScreen";
import { ModalSolicitudCredito } from "./Modales/ModalSolicitudCredito";
import MdlSolicitudCreditoScreen from "./Modales/MdlSolicitudCreditoScreen";
import { CargarDocumentacionAsesor } from "./CreditoMhusa/CargarDocumentacionAsesor";
import { AnalizarDocumentacion } from "./CreditoMhusa/AnalizarDocumentacion";
import { MhusaFinalizacion } from "./CreditoMhusa/MhusaFinalizacion";
import TimeLineTarget from "./TimeLine/TimeLineTarget";
import ComputerIcon from "@mui/icons-material/Computer";
import { AnalisisComentariosLine } from "./AnalisisComentariosLine";
import { MhusaCargarPAgareEquip } from "./CreditoMhusa/MhusaCargarPAgareEquip";
import { PrestamoClientesCargarPagareEquip } from "../Credito/PrestamoClientes/PrestamoClientesCargarPagareEquip";
import { AnalizarDocumentacionVigencia } from "./CreditoMhusa/AnalizarDocumentacionVigencia";
import { obtenerPasosHabilitados } from "../../Helpers/TimelineHelper";
import { PrestamoFinalizacion } from "./CreditoMhusa/PrestamoFinalizacion";

export const AnalisisCreditoPrestamoCliente = ({ data, estado, upload, direccion }) => {
  const { state } = useContext(AnalisisCreditoContext);
  const [openSolicitud, setOpenSolicitud] = useState(false);
  const [comentarios, setComentario] = useState([]);
  const [value, setValue] = useState(0);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  useEffect(() => {
    onActualizarComentarios();
  }, []);
  const onActualizarComentarios = () => {
    if (
      state.folio === undefined ||
      state.folio === null ||
      state.folio.length !== 13
    ) {
      return;
    }
    setLoader({ ...loader, mostrar: true });
    request
      .get(`AnalisisSolicitudCreditoComentarios/Listado?folio=${state.folio}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });

        // setComentario(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PRESTAMO A CLIENTES", JSON.stringify(error), "error");
      });
  };
  return (
    <PlantillaScreen
      titulo={"PROCESO DE SOLICITUD DE PRESTAMO A CLIENTES"}
      className={"analisis-sc-procesos"}
    >
      <LoaderScreen loader={loader} />
      <ModalSolicitudCredito
        open={openSolicitud}
        setOpenSolicitud={setOpenSolicitud}
        value={value}
        setValue={setValue}
        upload={upload}
        maxValue={Number(estado.pantallacompleta)}
        pasosHabilitados={obtenerPasosHabilitados(data)}
        screens={{
          screen0: (
            <MdlSolicitudCreditoScreen
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen1: (
            <CargarDocumentacionAsesor
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              idproceso={30}
            />
          ),
          screen2: (
            <AnalizarDocumentacionVigencia
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
              idproceso={31}
            />
          ),
          screen3: (
            <PrestamoClientesCargarPagareEquip
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
          screen4: (
            <PrestamoFinalizacion
              folio={state.folio}
              setLoader={setLoader}
              loader={loader}
            />
          ),
        }}
        titulos={{
          screen0: "SOLICITUD DE CREDITO",
          screen1: "CARGAR DOCUMENTACION",
          screen2: "ANALIZAR DOCUMENTACION",
          screen3: "CAPTURAR INFORMACION EQUIP",
          screen4: "FINALIZAR SOLICITUD",
        }}
      />
      <div className="analisis-sc-procesos-timeline-title ">
        {state.cliente}
      </div>
      <div className="analisis-sc-procesos-timeline scroll-4">
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Genero Solicitud"}
          subtitle={"Vendedor"}
          footer={{
            tiempoestimado: data[0].estado,
            leyenda: data[0].creado,
            duracion: data[0].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[0].control}
          active={1 === Number(estado.pantallacompleta)}
          value={0}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Cargar Documentación"}
          subtitle={"Asesor de Ventas"}
          footer={{
            tiempoestimado: data[1].estado,
            leyenda: data[1].creado,
            duracion: data[1].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[1].control}
          active={2 === Number(estado.pantallacompleta)}
          value={1}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Analizar Documentación"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[2].estado,
            leyenda: data[2].creado,
            duracion: data[2].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[2].control}
          active={3 === Number(estado.pantallacompleta)}
          value={2}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Cargar Pagare EQUIP"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[3].estado,
            leyenda: data[3].creado,
            duracion: data[3].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[3].control}
          active={4 === Number(estado.pantallacompleta)}
          value={3}
          setValue={setValue}
        />
        <TimeLineTarget
          icon={<ComputerIcon />}
          title={"Finalizar Solicitud"}
          subtitle={"Coordinador Credito"}
          footer={{
            tiempoestimado: data[4].estado,
            leyenda: data[4].creado,
            duracion: data[4].tiempoestimado,
            comentarios: "",
          }}
          openModal={setOpenSolicitud}
          color={data[4].control}
          active={5 === Number(estado.pantallacompleta)}
          value={4}
          setValue={setValue}
          endtarget={true}
        />
      </div>
      <AnalisisComentariosLine
        tiempotranscurrido={estado.tiempotranscurrido}
        tiempoestimado={estado.tiempoestimado}
        comentarios={comentarios}
      />
    </PlantillaScreen>
  );
};
